import {AfriexRoles} from '@/types';

/**
 * For the compose preview only: the server derives the published label from
 * the caller's role with the same mapping (BusinessUpdateInteractor).
 */
export const getAuthorRoleLabel = (role?: AfriexRoles): string => {
  switch (role) {
    case AfriexRoles.OPERATIONS_MANAGER:
    case AfriexRoles.OPERATIONS_MEMBER:
      return 'Ops';
    case AfriexRoles.GROWTH_MANAGER:
    case AfriexRoles.GROWTH_MEMBER:
      return 'Growth';
    case AfriexRoles.PRODUCT_ENG_QA_DESIGN_MANAGER:
    case AfriexRoles.PRODUCT_ENG_QA_DESIGN_MEMBER:
      return 'Product & Engineering';
    default:
      return 'Team';
  }
};
